/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Review.Api
 * OpenAPI spec version: 1.0
 */
import type { MutationFunction, QueryFunction, QueryKey, UseMutationOptions, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    AddReturnsToExistingFolderRequest,
    AddReturnsToExistingFolderResponse,
    AdjustmentAccountAndAmountAssociationRequest,
    AdjustmentAccountAndAmountAssociationsResponse,
    AmountDataEntryOptions,
    AmountsEntriesResponse,
    BaseStackResponse,
    Calculation,
    CalculationExecutionStatus,
    CalculationExecutionStatuses,
    CalculationExecutionStatusRequest,
    CancelScheduledCalculationRequest,
    ChangeTaxReturnStatusResponse,
    CreateFolderWithTaxReturnsRequest,
    CreateFolderWithTaxReturnsResponse,
    CustomGroup,
    CustomRange,
    DeleteDetailedWorkspaceRequest,
    DeleteFolderRequest,
    DeleteReturnsFromFolderRequest,
    DeleteReturnsFromFolderResponse,
    DoesCalculationDiagnosticsExistParams,
    DownloadTaxReturnPdfParams,
    EntitiesAndEntityGroupsResponse,
    ExtractionDetailsAccountSummary,
    GetAmountsEntriesParams,
    GetAmountsEntryOptionsParams,
    GetCalculationDiagnosticsParams,
    GetComparedWhitePaperReportParams,
    GetEntityEfileDataParams,
    GetTaxReturnsNameListParams,
    GetWhitePaperReportParams,
    GetWhitePaperReportPreviousVersionsParams,
    IWhitePaperReport,
    JobBatchProcessResponse,
    ProblemDetails,
    RenameFolderResponse,
    RenameTaxReturnFolderRecordParams,
    Report,
    ReportCellAuditExportRequest,
    ReportCellAuditRequest,
    ReportListRequest,
    ReportListResponse,
    ReportRowTraceExportRequest,
    ReturnExecutionInformation,
    ReturnFolderDto,
    SaveAmountsRequest,
    SaveAmountsResponse,
    SaveCalculationOptionsRequest,
    SaveCalculationOptionsResponse,
    SaveDetailedWorkspaceRequest,
    SaveTaxReturnFolderRecordParams,
    ScheduleBatchResponse,
    ScheduleReturnRequest,
    ScheduleTaxReturnCalculationRequest,
    SetTaxReturnStatusParams,
    TaxReturnDeleteRecordsRequest,
    TaxReturnItemRequest,
    TaxReturnPdfReportAvailableRequest,
    TaxReturnSaveRecordsRequest,
    TaxReturnSaveRecordsResponse,
    TaxReturnTOC,
    TaxReturnTOCRequest,
    ViewFormResponse,
    WhitePaperReportExportRequest,
    WhitePaperReportVersion,
} from '../../model';
import type { ErrorType } from '../../utils/UseCustomInstance';
import { useCustomInstance } from '../../utils/UseCustomInstance';

export const useGetTaxReturnsHook = () => {
    const getTaxReturns = useCustomInstance<ReportListResponse>();

    return (reportListRequest: ReportListRequest) => {
        return getTaxReturns({ url: `/Report`, method: 'post', headers: { 'Content-Type': 'application/json' }, data: reportListRequest });
    };
};

export const useGetTaxReturnsMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useGetTaxReturnsHook>>>,
        TError,
        { data: ReportListRequest },
        TContext
    >;
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useGetTaxReturnsHook>>>, TError, { data: ReportListRequest }, TContext> => {
    const { mutation: mutationOptions } = options ?? {};

    const getTaxReturns = useGetTaxReturnsHook();

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useGetTaxReturnsHook>>>, { data: ReportListRequest }> = (
        props
    ) => {
        const { data } = props ?? {};

        return getTaxReturns(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type GetTaxReturnsMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTaxReturnsHook>>>>;
export type GetTaxReturnsMutationBody = ReportListRequest;
export type GetTaxReturnsMutationError = ErrorType<ProblemDetails>;

export const useGetTaxReturns = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useGetTaxReturnsHook>>>,
        TError,
        { data: ReportListRequest },
        TContext
    >;
}) => {
    const mutationOptions = useGetTaxReturnsMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useGetTaxReturnsNameListHook = () => {
    const getTaxReturnsNameList = useCustomInstance<string[]>();

    return (params?: GetTaxReturnsNameListParams, signal?: AbortSignal) => {
        return getTaxReturnsNameList({ url: `/Report/GetTaxReturnsNameList`, method: 'get', params, signal });
    };
};

export const getGetTaxReturnsNameListQueryKey = (params?: GetTaxReturnsNameListParams) =>
    [`/Report/GetTaxReturnsNameList`, ...(params ? [params] : [])] as const;

export const useGetTaxReturnsNameListQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetTaxReturnsNameListHook>>>,
    TError = ErrorType<ProblemDetails>
>(
    params?: GetTaxReturnsNameListParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaxReturnsNameListHook>>>, TError, TData> }
): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaxReturnsNameListHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetTaxReturnsNameListQueryKey(params);

    const getTaxReturnsNameList = useGetTaxReturnsNameListHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTaxReturnsNameListHook>>>> = ({ signal }) =>
        getTaxReturnsNameList(params, signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetTaxReturnsNameListQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTaxReturnsNameListHook>>>>;
export type GetTaxReturnsNameListQueryError = ErrorType<ProblemDetails>;

export const useGetTaxReturnsNameList = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetTaxReturnsNameListHook>>>,
    TError = ErrorType<ProblemDetails>
>(
    params?: GetTaxReturnsNameListParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaxReturnsNameListHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetTaxReturnsNameListQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useGetTaxReturnByIdHook = () => {
    const getTaxReturnById = useCustomInstance<Report>();

    return (reportId: number, signal?: AbortSignal) => {
        return getTaxReturnById({ url: `/Report/${reportId}`, method: 'get', signal });
    };
};

export const getGetTaxReturnByIdQueryKey = (reportId: number) => [`/Report/${reportId}`] as const;

export const useGetTaxReturnByIdQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetTaxReturnByIdHook>>>,
    TError = ErrorType<ProblemDetails>
>(
    reportId: number,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaxReturnByIdHook>>>, TError, TData> }
): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaxReturnByIdHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetTaxReturnByIdQueryKey(reportId);

    const getTaxReturnById = useGetTaxReturnByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTaxReturnByIdHook>>>> = ({ signal }) =>
        getTaxReturnById(reportId, signal);

    return { queryKey, queryFn, enabled: !!reportId, ...queryOptions };
};

export type GetTaxReturnByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTaxReturnByIdHook>>>>;
export type GetTaxReturnByIdQueryError = ErrorType<ProblemDetails>;

export const useGetTaxReturnById = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetTaxReturnByIdHook>>>,
    TError = ErrorType<ProblemDetails>
>(
    reportId: number,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTaxReturnByIdHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetTaxReturnByIdQueryOptions(reportId, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useGetLatestExecutionInformationHook = () => {
    const getLatestExecutionInformation = useCustomInstance<ReturnExecutionInformation>();

    return (reportId: number) => {
        return getLatestExecutionInformation({ url: `/Report/LatestExecution/${reportId}`, method: 'post' });
    };
};

export const useGetLatestExecutionInformationMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useGetLatestExecutionInformationHook>>>,
        TError,
        { reportId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useGetLatestExecutionInformationHook>>>,
    TError,
    { reportId: number },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const getLatestExecutionInformation = useGetLatestExecutionInformationHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useGetLatestExecutionInformationHook>>>,
        { reportId: number }
    > = (props) => {
        const { reportId } = props ?? {};

        return getLatestExecutionInformation(reportId);
    };

    return { mutationFn, ...mutationOptions };
};

export type GetLatestExecutionInformationMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetLatestExecutionInformationHook>>>
>;

export type GetLatestExecutionInformationMutationError = ErrorType<ProblemDetails>;

export const useGetLatestExecutionInformation = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useGetLatestExecutionInformationHook>>>,
        TError,
        { reportId: number },
        TContext
    >;
}) => {
    const mutationOptions = useGetLatestExecutionInformationMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useSetTaxReturnStatusHook = () => {
    const setTaxReturnStatus = useCustomInstance<ChangeTaxReturnStatusResponse>();

    return (reportId: number, params?: SetTaxReturnStatusParams) => {
        return setTaxReturnStatus({ url: `/Report/${reportId}/status`, method: 'post', params });
    };
};

export const useSetTaxReturnStatusMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSetTaxReturnStatusHook>>>,
        TError,
        { reportId: number; params?: SetTaxReturnStatusParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSetTaxReturnStatusHook>>>,
    TError,
    { reportId: number; params?: SetTaxReturnStatusParams },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const setTaxReturnStatus = useSetTaxReturnStatusHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useSetTaxReturnStatusHook>>>,
        { reportId: number; params?: SetTaxReturnStatusParams }
    > = (props) => {
        const { reportId, params } = props ?? {};

        return setTaxReturnStatus(reportId, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type SetTaxReturnStatusMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSetTaxReturnStatusHook>>>>;

export type SetTaxReturnStatusMutationError = ErrorType<ProblemDetails>;

export const useSetTaxReturnStatus = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSetTaxReturnStatusHook>>>,
        TError,
        { reportId: number; params?: SetTaxReturnStatusParams },
        TContext
    >;
}) => {
    const mutationOptions = useSetTaxReturnStatusMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useGetWhitePaperReportHook = () => {
    const getWhitePaperReport = useCustomInstance<IWhitePaperReport>();

    return (params?: GetWhitePaperReportParams, signal?: AbortSignal) => {
        return getWhitePaperReport({ url: `/Report/view`, method: 'get', params, signal });
    };
};

export const getGetWhitePaperReportQueryKey = (params?: GetWhitePaperReportParams) =>
    [`/Report/view`, ...(params ? [params] : [])] as const;

export const useGetWhitePaperReportQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetWhitePaperReportHook>>>,
    TError = ErrorType<ProblemDetails>
>(
    params?: GetWhitePaperReportParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWhitePaperReportHook>>>, TError, TData> }
): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWhitePaperReportHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetWhitePaperReportQueryKey(params);

    const getWhitePaperReport = useGetWhitePaperReportHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetWhitePaperReportHook>>>> = ({ signal }) =>
        getWhitePaperReport(params, signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetWhitePaperReportQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetWhitePaperReportHook>>>>;
export type GetWhitePaperReportQueryError = ErrorType<ProblemDetails>;

export const useGetWhitePaperReport = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetWhitePaperReportHook>>>,
    TError = ErrorType<ProblemDetails>
>(
    params?: GetWhitePaperReportParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWhitePaperReportHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetWhitePaperReportQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useGetComparedWhitePaperReportHook = () => {
    const getComparedWhitePaperReport = useCustomInstance<IWhitePaperReport>();

    return (params?: GetComparedWhitePaperReportParams, signal?: AbortSignal) => {
        return getComparedWhitePaperReport({ url: `/Report/compare`, method: 'get', params, signal });
    };
};

export const getGetComparedWhitePaperReportQueryKey = (params?: GetComparedWhitePaperReportParams) =>
    [`/Report/compare`, ...(params ? [params] : [])] as const;

export const useGetComparedWhitePaperReportQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetComparedWhitePaperReportHook>>>,
    TError = ErrorType<ProblemDetails>
>(
    params?: GetComparedWhitePaperReportParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetComparedWhitePaperReportHook>>>, TError, TData> }
): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetComparedWhitePaperReportHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetComparedWhitePaperReportQueryKey(params);

    const getComparedWhitePaperReport = useGetComparedWhitePaperReportHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetComparedWhitePaperReportHook>>>> = ({ signal }) =>
        getComparedWhitePaperReport(params, signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetComparedWhitePaperReportQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetComparedWhitePaperReportHook>>>
>;
export type GetComparedWhitePaperReportQueryError = ErrorType<ProblemDetails>;

export const useGetComparedWhitePaperReport = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetComparedWhitePaperReportHook>>>,
    TError = ErrorType<ProblemDetails>
>(
    params?: GetComparedWhitePaperReportParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetComparedWhitePaperReportHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetComparedWhitePaperReportQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useScheduleTaxReturnCalculationHook = () => {
    const scheduleTaxReturnCalculation = useCustomInstance<JobBatchProcessResponse>();

    return (scheduleTaxReturnCalculationRequest: ScheduleTaxReturnCalculationRequest) => {
        return scheduleTaxReturnCalculation({
            url: `/Report/recalculate`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: scheduleTaxReturnCalculationRequest,
        });
    };
};

export const useScheduleTaxReturnCalculationMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useScheduleTaxReturnCalculationHook>>>,
        TError,
        { data: ScheduleTaxReturnCalculationRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useScheduleTaxReturnCalculationHook>>>,
    TError,
    { data: ScheduleTaxReturnCalculationRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const scheduleTaxReturnCalculation = useScheduleTaxReturnCalculationHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useScheduleTaxReturnCalculationHook>>>,
        { data: ScheduleTaxReturnCalculationRequest }
    > = (props) => {
        const { data } = props ?? {};

        return scheduleTaxReturnCalculation(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ScheduleTaxReturnCalculationMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useScheduleTaxReturnCalculationHook>>>
>;
export type ScheduleTaxReturnCalculationMutationBody = ScheduleTaxReturnCalculationRequest;
export type ScheduleTaxReturnCalculationMutationError = ErrorType<ProblemDetails>;

export const useScheduleTaxReturnCalculation = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useScheduleTaxReturnCalculationHook>>>,
        TError,
        { data: ScheduleTaxReturnCalculationRequest },
        TContext
    >;
}) => {
    const mutationOptions = useScheduleTaxReturnCalculationMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useCancelScheduledCalculationHook = () => {
    const cancelScheduledCalculation = useCustomInstance<boolean>();

    return (cancelScheduledCalculationRequest: CancelScheduledCalculationRequest) => {
        return cancelScheduledCalculation({
            url: `/Report/CancelScheduledCalculation`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: cancelScheduledCalculationRequest,
        });
    };
};

export const useCancelScheduledCalculationMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCancelScheduledCalculationHook>>>,
        TError,
        { data: CancelScheduledCalculationRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCancelScheduledCalculationHook>>>,
    TError,
    { data: CancelScheduledCalculationRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const cancelScheduledCalculation = useCancelScheduledCalculationHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCancelScheduledCalculationHook>>>,
        { data: CancelScheduledCalculationRequest }
    > = (props) => {
        const { data } = props ?? {};

        return cancelScheduledCalculation(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type CancelScheduledCalculationMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCancelScheduledCalculationHook>>>
>;
export type CancelScheduledCalculationMutationBody = CancelScheduledCalculationRequest;
export type CancelScheduledCalculationMutationError = ErrorType<ProblemDetails>;

export const useCancelScheduledCalculation = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCancelScheduledCalculationHook>>>,
        TError,
        { data: CancelScheduledCalculationRequest },
        TContext
    >;
}) => {
    const mutationOptions = useCancelScheduledCalculationMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useGetAllFoldersHook = () => {
    const getAllFolders = useCustomInstance<ReturnFolderDto[]>();

    return (signal?: AbortSignal) => {
        return getAllFolders({ url: `/Report/GetAllFolders`, method: 'get', signal });
    };
};

export const getGetAllFoldersQueryKey = () => [`/Report/GetAllFolders`] as const;

export const useGetAllFoldersQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetAllFoldersHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllFoldersHook>>>, TError, TData>;
}): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllFoldersHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAllFoldersQueryKey();

    const getAllFolders = useGetAllFoldersHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAllFoldersHook>>>> = ({ signal }) => getAllFolders(signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetAllFoldersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAllFoldersHook>>>>;
export type GetAllFoldersQueryError = ErrorType<ProblemDetails>;

export const useGetAllFolders = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetAllFoldersHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAllFoldersHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetAllFoldersQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useSaveTaxReturnFolderRecordHook = () => {
    const saveTaxReturnFolderRecord = useCustomInstance<BaseStackResponse>();

    return (params?: SaveTaxReturnFolderRecordParams) => {
        return saveTaxReturnFolderRecord({ url: `/Report/SaveTaxReturnFolderRecord`, method: 'post', params });
    };
};

export const useSaveTaxReturnFolderRecordMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSaveTaxReturnFolderRecordHook>>>,
        TError,
        { params?: SaveTaxReturnFolderRecordParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSaveTaxReturnFolderRecordHook>>>,
    TError,
    { params?: SaveTaxReturnFolderRecordParams },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const saveTaxReturnFolderRecord = useSaveTaxReturnFolderRecordHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useSaveTaxReturnFolderRecordHook>>>,
        { params?: SaveTaxReturnFolderRecordParams }
    > = (props) => {
        const { params } = props ?? {};

        return saveTaxReturnFolderRecord(params);
    };

    return { mutationFn, ...mutationOptions };
};

export type SaveTaxReturnFolderRecordMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSaveTaxReturnFolderRecordHook>>>>;

export type SaveTaxReturnFolderRecordMutationError = ErrorType<ProblemDetails>;

export const useSaveTaxReturnFolderRecord = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSaveTaxReturnFolderRecordHook>>>,
        TError,
        { params?: SaveTaxReturnFolderRecordParams },
        TContext
    >;
}) => {
    const mutationOptions = useSaveTaxReturnFolderRecordMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useDeleteTaxReturnFolderRecordHook = () => {
    const deleteTaxReturnFolderRecord = useCustomInstance<BaseStackResponse>();

    return (deleteFolderRequest: DeleteFolderRequest) => {
        return deleteTaxReturnFolderRecord({
            url: `/Report/DeleteTaxReturnFolderRecord`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: deleteFolderRequest,
        });
    };
};

export const useDeleteTaxReturnFolderRecordMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteTaxReturnFolderRecordHook>>>,
        TError,
        { data: DeleteFolderRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteTaxReturnFolderRecordHook>>>,
    TError,
    { data: DeleteFolderRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const deleteTaxReturnFolderRecord = useDeleteTaxReturnFolderRecordHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeleteTaxReturnFolderRecordHook>>>,
        { data: DeleteFolderRequest }
    > = (props) => {
        const { data } = props ?? {};

        return deleteTaxReturnFolderRecord(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteTaxReturnFolderRecordMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeleteTaxReturnFolderRecordHook>>>
>;
export type DeleteTaxReturnFolderRecordMutationBody = DeleteFolderRequest;
export type DeleteTaxReturnFolderRecordMutationError = ErrorType<ProblemDetails>;

export const useDeleteTaxReturnFolderRecord = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteTaxReturnFolderRecordHook>>>,
        TError,
        { data: DeleteFolderRequest },
        TContext
    >;
}) => {
    const mutationOptions = useDeleteTaxReturnFolderRecordMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useRenameTaxReturnFolderRecordHook = () => {
    const renameTaxReturnFolderRecord = useCustomInstance<RenameFolderResponse>();

    return (params: RenameTaxReturnFolderRecordParams) => {
        return renameTaxReturnFolderRecord({ url: `/Report/RenameTaxReturnFolderRecord`, method: 'post', params });
    };
};

export const useRenameTaxReturnFolderRecordMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useRenameTaxReturnFolderRecordHook>>>,
        TError,
        { params: RenameTaxReturnFolderRecordParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRenameTaxReturnFolderRecordHook>>>,
    TError,
    { params: RenameTaxReturnFolderRecordParams },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const renameTaxReturnFolderRecord = useRenameTaxReturnFolderRecordHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useRenameTaxReturnFolderRecordHook>>>,
        { params: RenameTaxReturnFolderRecordParams }
    > = (props) => {
        const { params } = props ?? {};

        return renameTaxReturnFolderRecord(params);
    };

    return { mutationFn, ...mutationOptions };
};

export type RenameTaxReturnFolderRecordMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useRenameTaxReturnFolderRecordHook>>>
>;

export type RenameTaxReturnFolderRecordMutationError = ErrorType<ProblemDetails>;

export const useRenameTaxReturnFolderRecord = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useRenameTaxReturnFolderRecordHook>>>,
        TError,
        { params: RenameTaxReturnFolderRecordParams },
        TContext
    >;
}) => {
    const mutationOptions = useRenameTaxReturnFolderRecordMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useGetReportCellAuditHook = () => {
    const getReportCellAudit = useCustomInstance<ExtractionDetailsAccountSummary[]>();

    return (reportCellAuditRequest: ReportCellAuditRequest) => {
        return getReportCellAudit({
            url: `/Report/GetReportCellAudit`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: reportCellAuditRequest,
        });
    };
};

export const useGetReportCellAuditMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useGetReportCellAuditHook>>>,
        TError,
        { data: ReportCellAuditRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useGetReportCellAuditHook>>>,
    TError,
    { data: ReportCellAuditRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const getReportCellAudit = useGetReportCellAuditHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useGetReportCellAuditHook>>>,
        { data: ReportCellAuditRequest }
    > = (props) => {
        const { data } = props ?? {};

        return getReportCellAudit(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type GetReportCellAuditMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetReportCellAuditHook>>>>;
export type GetReportCellAuditMutationBody = ReportCellAuditRequest;
export type GetReportCellAuditMutationError = ErrorType<ProblemDetails>;

export const useGetReportCellAudit = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useGetReportCellAuditHook>>>,
        TError,
        { data: ReportCellAuditRequest },
        TContext
    >;
}) => {
    const mutationOptions = useGetReportCellAuditMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useGetWhitePaperReportPreviousVersionsHook = () => {
    const getWhitePaperReportPreviousVersions = useCustomInstance<WhitePaperReportVersion[]>();

    return (params?: GetWhitePaperReportPreviousVersionsParams, signal?: AbortSignal) => {
        return getWhitePaperReportPreviousVersions({ url: `/Report/versions`, method: 'get', params, signal });
    };
};

export const getGetWhitePaperReportPreviousVersionsQueryKey = (params?: GetWhitePaperReportPreviousVersionsParams) =>
    [`/Report/versions`, ...(params ? [params] : [])] as const;

export const useGetWhitePaperReportPreviousVersionsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetWhitePaperReportPreviousVersionsHook>>>,
    TError = ErrorType<ProblemDetails>
>(
    params?: GetWhitePaperReportPreviousVersionsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWhitePaperReportPreviousVersionsHook>>>, TError, TData> }
): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWhitePaperReportPreviousVersionsHook>>>, TError, TData> & {
    queryKey: QueryKey;
} => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetWhitePaperReportPreviousVersionsQueryKey(params);

    const getWhitePaperReportPreviousVersions = useGetWhitePaperReportPreviousVersionsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetWhitePaperReportPreviousVersionsHook>>>> = ({ signal }) =>
        getWhitePaperReportPreviousVersions(params, signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetWhitePaperReportPreviousVersionsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetWhitePaperReportPreviousVersionsHook>>>
>;
export type GetWhitePaperReportPreviousVersionsQueryError = ErrorType<ProblemDetails>;

export const useGetWhitePaperReportPreviousVersions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetWhitePaperReportPreviousVersionsHook>>>,
    TError = ErrorType<ProblemDetails>
>(
    params?: GetWhitePaperReportPreviousVersionsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWhitePaperReportPreviousVersionsHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetWhitePaperReportPreviousVersionsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useExportReportToExcelHook = () => {
    const exportReportToExcel = useCustomInstance<Blob>();

    return (whitePaperReportExportRequest: WhitePaperReportExportRequest[]) => {
        return exportReportToExcel({
            url: `/Report/Export`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: whitePaperReportExportRequest,
            responseType: 'blob',
        });
    };
};

export const useExportReportToExcelMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useExportReportToExcelHook>>>,
        TError,
        { data: WhitePaperReportExportRequest[] },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportReportToExcelHook>>>,
    TError,
    { data: WhitePaperReportExportRequest[] },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const exportReportToExcel = useExportReportToExcelHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useExportReportToExcelHook>>>,
        { data: WhitePaperReportExportRequest[] }
    > = (props) => {
        const { data } = props ?? {};

        return exportReportToExcel(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ExportReportToExcelMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportReportToExcelHook>>>>;
export type ExportReportToExcelMutationBody = WhitePaperReportExportRequest[];
export type ExportReportToExcelMutationError = ErrorType<ProblemDetails>;

export const useExportReportToExcel = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useExportReportToExcelHook>>>,
        TError,
        { data: WhitePaperReportExportRequest[] },
        TContext
    >;
}) => {
    const mutationOptions = useExportReportToExcelMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useExportTaxReturnListToExcelHook = () => {
    const exportTaxReturnListToExcel = useCustomInstance<Blob>();

    return (reportListRequest: ReportListRequest) => {
        return exportTaxReturnListToExcel({
            url: `/Report/ExportTaxReturnList`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: reportListRequest,
            responseType: 'blob',
        });
    };
};

export const useExportTaxReturnListToExcelMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useExportTaxReturnListToExcelHook>>>,
        TError,
        { data: ReportListRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportTaxReturnListToExcelHook>>>,
    TError,
    { data: ReportListRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const exportTaxReturnListToExcel = useExportTaxReturnListToExcelHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useExportTaxReturnListToExcelHook>>>,
        { data: ReportListRequest }
    > = (props) => {
        const { data } = props ?? {};

        return exportTaxReturnListToExcel(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ExportTaxReturnListToExcelMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useExportTaxReturnListToExcelHook>>>
>;
export type ExportTaxReturnListToExcelMutationBody = ReportListRequest;
export type ExportTaxReturnListToExcelMutationError = ErrorType<ProblemDetails>;

export const useExportTaxReturnListToExcel = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useExportTaxReturnListToExcelHook>>>,
        TError,
        { data: ReportListRequest },
        TContext
    >;
}) => {
    const mutationOptions = useExportTaxReturnListToExcelMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useExportReportToPDFHook = () => {
    const exportReportToPDF = useCustomInstance<Blob>();

    return (whitePaperReportExportRequest: WhitePaperReportExportRequest[]) => {
        return exportReportToPDF({
            url: `/Report/ExportPDF`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: whitePaperReportExportRequest,
            responseType: 'blob',
        });
    };
};

export const useExportReportToPDFMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useExportReportToPDFHook>>>,
        TError,
        { data: WhitePaperReportExportRequest[] },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportReportToPDFHook>>>,
    TError,
    { data: WhitePaperReportExportRequest[] },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const exportReportToPDF = useExportReportToPDFHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useExportReportToPDFHook>>>,
        { data: WhitePaperReportExportRequest[] }
    > = (props) => {
        const { data } = props ?? {};

        return exportReportToPDF(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ExportReportToPDFMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useExportReportToPDFHook>>>>;
export type ExportReportToPDFMutationBody = WhitePaperReportExportRequest[];
export type ExportReportToPDFMutationError = ErrorType<ProblemDetails>;

export const useExportReportToPDF = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useExportReportToPDFHook>>>,
        TError,
        { data: WhitePaperReportExportRequest[] },
        TContext
    >;
}) => {
    const mutationOptions = useExportReportToPDFMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useViewFormHook = () => {
    const viewForm = useCustomInstance<ViewFormResponse>();

    return (taxReturnItemRequest: TaxReturnItemRequest) => {
        return viewForm({
            url: `/Report/ViewForm`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: taxReturnItemRequest,
        });
    };
};

export const useViewFormMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useViewFormHook>>>,
        TError,
        { data: TaxReturnItemRequest },
        TContext
    >;
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useViewFormHook>>>, TError, { data: TaxReturnItemRequest }, TContext> => {
    const { mutation: mutationOptions } = options ?? {};

    const viewForm = useViewFormHook();

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useViewFormHook>>>, { data: TaxReturnItemRequest }> = (
        props
    ) => {
        const { data } = props ?? {};

        return viewForm(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ViewFormMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useViewFormHook>>>>;
export type ViewFormMutationBody = TaxReturnItemRequest;
export type ViewFormMutationError = ErrorType<ProblemDetails>;

export const useViewForm = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useViewFormHook>>>,
        TError,
        { data: TaxReturnItemRequest },
        TContext
    >;
}) => {
    const mutationOptions = useViewFormMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useGetTaxReturnPrintSelectionTOCHook = () => {
    const getTaxReturnPrintSelectionTOC = useCustomInstance<TaxReturnTOC>();

    return (taxReturnTOCRequest: TaxReturnTOCRequest) => {
        return getTaxReturnPrintSelectionTOC({
            url: `/Report/GetTaxReturnPrintSelectionTOC`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: taxReturnTOCRequest,
        });
    };
};

export const useGetTaxReturnPrintSelectionTOCMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useGetTaxReturnPrintSelectionTOCHook>>>,
        TError,
        { data: TaxReturnTOCRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useGetTaxReturnPrintSelectionTOCHook>>>,
    TError,
    { data: TaxReturnTOCRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const getTaxReturnPrintSelectionTOC = useGetTaxReturnPrintSelectionTOCHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useGetTaxReturnPrintSelectionTOCHook>>>,
        { data: TaxReturnTOCRequest }
    > = (props) => {
        const { data } = props ?? {};

        return getTaxReturnPrintSelectionTOC(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type GetTaxReturnPrintSelectionTOCMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetTaxReturnPrintSelectionTOCHook>>>
>;
export type GetTaxReturnPrintSelectionTOCMutationBody = TaxReturnTOCRequest;
export type GetTaxReturnPrintSelectionTOCMutationError = ErrorType<ProblemDetails>;

export const useGetTaxReturnPrintSelectionTOC = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useGetTaxReturnPrintSelectionTOCHook>>>,
        TError,
        { data: TaxReturnTOCRequest },
        TContext
    >;
}) => {
    const mutationOptions = useGetTaxReturnPrintSelectionTOCMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useGetTaxReturnTOCHook = () => {
    const getTaxReturnTOC = useCustomInstance<TaxReturnTOC>();

    return (taxReturnTOCRequest: TaxReturnTOCRequest) => {
        return getTaxReturnTOC({
            url: `/Report/GetTaxReturnTOC`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: taxReturnTOCRequest,
        });
    };
};

export const useGetTaxReturnTOCMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useGetTaxReturnTOCHook>>>,
        TError,
        { data: TaxReturnTOCRequest },
        TContext
    >;
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useGetTaxReturnTOCHook>>>, TError, { data: TaxReturnTOCRequest }, TContext> => {
    const { mutation: mutationOptions } = options ?? {};

    const getTaxReturnTOC = useGetTaxReturnTOCHook();

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useGetTaxReturnTOCHook>>>, { data: TaxReturnTOCRequest }> = (
        props
    ) => {
        const { data } = props ?? {};

        return getTaxReturnTOC(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type GetTaxReturnTOCMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTaxReturnTOCHook>>>>;
export type GetTaxReturnTOCMutationBody = TaxReturnTOCRequest;
export type GetTaxReturnTOCMutationError = ErrorType<ProblemDetails>;

export const useGetTaxReturnTOC = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useGetTaxReturnTOCHook>>>,
        TError,
        { data: TaxReturnTOCRequest },
        TContext
    >;
}) => {
    const mutationOptions = useGetTaxReturnTOCMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useSaveDetailedWorkspaceHook = () => {
    const saveDetailedWorkspace = useCustomInstance<void>();

    return (saveDetailedWorkspaceRequest: SaveDetailedWorkspaceRequest) => {
        return saveDetailedWorkspace({
            url: `/Report/SaveDetailedWorkspace`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: saveDetailedWorkspaceRequest,
        });
    };
};

export const useSaveDetailedWorkspaceMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSaveDetailedWorkspaceHook>>>,
        TError,
        { data: SaveDetailedWorkspaceRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSaveDetailedWorkspaceHook>>>,
    TError,
    { data: SaveDetailedWorkspaceRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const saveDetailedWorkspace = useSaveDetailedWorkspaceHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useSaveDetailedWorkspaceHook>>>,
        { data: SaveDetailedWorkspaceRequest }
    > = (props) => {
        const { data } = props ?? {};

        return saveDetailedWorkspace(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type SaveDetailedWorkspaceMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSaveDetailedWorkspaceHook>>>>;
export type SaveDetailedWorkspaceMutationBody = SaveDetailedWorkspaceRequest;
export type SaveDetailedWorkspaceMutationError = ErrorType<ProblemDetails>;

export const useSaveDetailedWorkspace = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSaveDetailedWorkspaceHook>>>,
        TError,
        { data: SaveDetailedWorkspaceRequest },
        TContext
    >;
}) => {
    const mutationOptions = useSaveDetailedWorkspaceMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useDeleteDetailedWorkspaceHook = () => {
    const deleteDetailedWorkspace = useCustomInstance<void>();

    return (deleteDetailedWorkspaceRequest: DeleteDetailedWorkspaceRequest) => {
        return deleteDetailedWorkspace({
            url: `/Report/DeleteDetailedWorkspace`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: deleteDetailedWorkspaceRequest,
        });
    };
};

export const useDeleteDetailedWorkspaceMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteDetailedWorkspaceHook>>>,
        TError,
        { data: DeleteDetailedWorkspaceRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteDetailedWorkspaceHook>>>,
    TError,
    { data: DeleteDetailedWorkspaceRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const deleteDetailedWorkspace = useDeleteDetailedWorkspaceHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeleteDetailedWorkspaceHook>>>,
        { data: DeleteDetailedWorkspaceRequest }
    > = (props) => {
        const { data } = props ?? {};

        return deleteDetailedWorkspace(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteDetailedWorkspaceMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteDetailedWorkspaceHook>>>>;
export type DeleteDetailedWorkspaceMutationBody = DeleteDetailedWorkspaceRequest;
export type DeleteDetailedWorkspaceMutationError = ErrorType<ProblemDetails>;

export const useDeleteDetailedWorkspace = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteDetailedWorkspaceHook>>>,
        TError,
        { data: DeleteDetailedWorkspaceRequest },
        TContext
    >;
}) => {
    const mutationOptions = useDeleteDetailedWorkspaceMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useSaveAmountsHook = () => {
    const saveAmounts = useCustomInstance<SaveAmountsResponse>();

    return (saveAmountsRequest: SaveAmountsRequest) => {
        return saveAmounts({
            url: `/Report/SaveAmounts`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: saveAmountsRequest,
        });
    };
};

export const useSaveAmountsMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSaveAmountsHook>>>,
        TError,
        { data: SaveAmountsRequest },
        TContext
    >;
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSaveAmountsHook>>>, TError, { data: SaveAmountsRequest }, TContext> => {
    const { mutation: mutationOptions } = options ?? {};

    const saveAmounts = useSaveAmountsHook();

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useSaveAmountsHook>>>, { data: SaveAmountsRequest }> = (
        props
    ) => {
        const { data } = props ?? {};

        return saveAmounts(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type SaveAmountsMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSaveAmountsHook>>>>;
export type SaveAmountsMutationBody = SaveAmountsRequest;
export type SaveAmountsMutationError = ErrorType<ProblemDetails>;

export const useSaveAmounts = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSaveAmountsHook>>>,
        TError,
        { data: SaveAmountsRequest },
        TContext
    >;
}) => {
    const mutationOptions = useSaveAmountsMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useSaveCalculationOptionsHook = () => {
    const saveCalculationOptions = useCustomInstance<SaveCalculationOptionsResponse>();

    return (saveCalculationOptionsRequest: SaveCalculationOptionsRequest) => {
        return saveCalculationOptions({
            url: `/Report/SaveCalculationOptions`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: saveCalculationOptionsRequest,
        });
    };
};

export const useSaveCalculationOptionsMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSaveCalculationOptionsHook>>>,
        TError,
        { data: SaveCalculationOptionsRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSaveCalculationOptionsHook>>>,
    TError,
    { data: SaveCalculationOptionsRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const saveCalculationOptions = useSaveCalculationOptionsHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useSaveCalculationOptionsHook>>>,
        { data: SaveCalculationOptionsRequest }
    > = (props) => {
        const { data } = props ?? {};

        return saveCalculationOptions(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type SaveCalculationOptionsMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSaveCalculationOptionsHook>>>>;
export type SaveCalculationOptionsMutationBody = SaveCalculationOptionsRequest;
export type SaveCalculationOptionsMutationError = ErrorType<ProblemDetails>;

export const useSaveCalculationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSaveCalculationOptionsHook>>>,
        TError,
        { data: SaveCalculationOptionsRequest },
        TContext
    >;
}) => {
    const mutationOptions = useSaveCalculationOptionsMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useGetCalculationExecutionStatusHook = () => {
    const getCalculationExecutionStatus = useCustomInstance<CalculationExecutionStatus[]>();

    return (calculationExecutionStatusRequest: CalculationExecutionStatusRequest) => {
        return getCalculationExecutionStatus({
            url: `/Report/GetCalculationExecutionStatus`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: calculationExecutionStatusRequest,
        });
    };
};

export const useGetCalculationExecutionStatusMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCalculationExecutionStatusHook>>>,
        TError,
        { data: CalculationExecutionStatusRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useGetCalculationExecutionStatusHook>>>,
    TError,
    { data: CalculationExecutionStatusRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const getCalculationExecutionStatus = useGetCalculationExecutionStatusHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useGetCalculationExecutionStatusHook>>>,
        { data: CalculationExecutionStatusRequest }
    > = (props) => {
        const { data } = props ?? {};

        return getCalculationExecutionStatus(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type GetCalculationExecutionStatusMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetCalculationExecutionStatusHook>>>
>;
export type GetCalculationExecutionStatusMutationBody = CalculationExecutionStatusRequest;
export type GetCalculationExecutionStatusMutationError = ErrorType<ProblemDetails>;

export const useGetCalculationExecutionStatus = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCalculationExecutionStatusHook>>>,
        TError,
        { data: CalculationExecutionStatusRequest },
        TContext
    >;
}) => {
    const mutationOptions = useGetCalculationExecutionStatusMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useGetCalculationExecutionStatusesHook = () => {
    const getCalculationExecutionStatuses = useCustomInstance<CalculationExecutionStatuses>();

    return () => {
        return getCalculationExecutionStatuses({ url: `/Report/GetCalculationExecutionStatuses`, method: 'post' });
    };
};

export const useGetCalculationExecutionStatusesMutationOptions = <
    TError = ErrorType<ProblemDetails>,
    TVariables = void,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCalculationExecutionStatusesHook>>>,
        TError,
        TVariables,
        TContext
    >;
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useGetCalculationExecutionStatusesHook>>>, TError, TVariables, TContext> => {
    const { mutation: mutationOptions } = options ?? {};

    const getCalculationExecutionStatuses = useGetCalculationExecutionStatusesHook();

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useGetCalculationExecutionStatusesHook>>>, TVariables> = () => {
        return getCalculationExecutionStatuses();
    };

    return { mutationFn, ...mutationOptions };
};

export type GetCalculationExecutionStatusesMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetCalculationExecutionStatusesHook>>>
>;

export type GetCalculationExecutionStatusesMutationError = ErrorType<ProblemDetails>;

export const useGetCalculationExecutionStatuses = <TError = ErrorType<ProblemDetails>, TVariables = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useGetCalculationExecutionStatusesHook>>>,
        TError,
        TVariables,
        TContext
    >;
}) => {
    const mutationOptions = useGetCalculationExecutionStatusesMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useExportReportCellAuditToExcelHook = () => {
    const exportReportCellAuditToExcel = useCustomInstance<Blob>();

    return (reportCellAuditExportRequest: ReportCellAuditExportRequest) => {
        return exportReportCellAuditToExcel({
            url: `/Report/ExportReportCellAuditToExcel`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: reportCellAuditExportRequest,
            responseType: 'blob',
        });
    };
};

export const useExportReportCellAuditToExcelMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useExportReportCellAuditToExcelHook>>>,
        TError,
        { data: ReportCellAuditExportRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportReportCellAuditToExcelHook>>>,
    TError,
    { data: ReportCellAuditExportRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const exportReportCellAuditToExcel = useExportReportCellAuditToExcelHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useExportReportCellAuditToExcelHook>>>,
        { data: ReportCellAuditExportRequest }
    > = (props) => {
        const { data } = props ?? {};

        return exportReportCellAuditToExcel(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ExportReportCellAuditToExcelMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useExportReportCellAuditToExcelHook>>>
>;
export type ExportReportCellAuditToExcelMutationBody = ReportCellAuditExportRequest;
export type ExportReportCellAuditToExcelMutationError = ErrorType<ProblemDetails>;

export const useExportReportCellAuditToExcel = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useExportReportCellAuditToExcelHook>>>,
        TError,
        { data: ReportCellAuditExportRequest },
        TContext
    >;
}) => {
    const mutationOptions = useExportReportCellAuditToExcelMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useExportReportRowTraceToExcelHook = () => {
    const exportReportRowTraceToExcel = useCustomInstance<Blob>();

    return (reportRowTraceExportRequest: ReportRowTraceExportRequest) => {
        return exportReportRowTraceToExcel({
            url: `/Report/ExportReportRowTraceToExcel`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: reportRowTraceExportRequest,
            responseType: 'blob',
        });
    };
};

export const useExportReportRowTraceToExcelMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useExportReportRowTraceToExcelHook>>>,
        TError,
        { data: ReportRowTraceExportRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExportReportRowTraceToExcelHook>>>,
    TError,
    { data: ReportRowTraceExportRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const exportReportRowTraceToExcel = useExportReportRowTraceToExcelHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useExportReportRowTraceToExcelHook>>>,
        { data: ReportRowTraceExportRequest }
    > = (props) => {
        const { data } = props ?? {};

        return exportReportRowTraceToExcel(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ExportReportRowTraceToExcelMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useExportReportRowTraceToExcelHook>>>
>;
export type ExportReportRowTraceToExcelMutationBody = ReportRowTraceExportRequest;
export type ExportReportRowTraceToExcelMutationError = ErrorType<ProblemDetails>;

export const useExportReportRowTraceToExcel = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useExportReportRowTraceToExcelHook>>>,
        TError,
        { data: ReportRowTraceExportRequest },
        TContext
    >;
}) => {
    const mutationOptions = useExportReportRowTraceToExcelMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @deprecated
 */
export const useGetAdjustmentAccountAssociationsHook = () => {
    const getAdjustmentAccountAssociations = useCustomInstance<AdjustmentAccountAndAmountAssociationsResponse>();

    return (adjustmentAccountAndAmountAssociationRequest: AdjustmentAccountAndAmountAssociationRequest) => {
        return getAdjustmentAccountAssociations({
            url: `/Report/GetAdjustmentAccountAssociations`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: adjustmentAccountAndAmountAssociationRequest,
        });
    };
};

export const useGetAdjustmentAccountAssociationsMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useGetAdjustmentAccountAssociationsHook>>>,
        TError,
        { data: AdjustmentAccountAndAmountAssociationRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useGetAdjustmentAccountAssociationsHook>>>,
    TError,
    { data: AdjustmentAccountAndAmountAssociationRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const getAdjustmentAccountAssociations = useGetAdjustmentAccountAssociationsHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useGetAdjustmentAccountAssociationsHook>>>,
        { data: AdjustmentAccountAndAmountAssociationRequest }
    > = (props) => {
        const { data } = props ?? {};

        return getAdjustmentAccountAssociations(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type GetAdjustmentAccountAssociationsMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetAdjustmentAccountAssociationsHook>>>
>;
export type GetAdjustmentAccountAssociationsMutationBody = AdjustmentAccountAndAmountAssociationRequest;
export type GetAdjustmentAccountAssociationsMutationError = ErrorType<ProblemDetails>;

/**
 * @deprecated
 */
export const useGetAdjustmentAccountAssociations = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useGetAdjustmentAccountAssociationsHook>>>,
        TError,
        { data: AdjustmentAccountAndAmountAssociationRequest },
        TContext
    >;
}) => {
    const mutationOptions = useGetAdjustmentAccountAssociationsMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useAddReturnsToExistingFolderHook = () => {
    const addReturnsToExistingFolder = useCustomInstance<AddReturnsToExistingFolderResponse>();

    return (addReturnsToExistingFolderRequest: AddReturnsToExistingFolderRequest) => {
        return addReturnsToExistingFolder({
            url: `/Report/AddReturnsToExistingFolder`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: addReturnsToExistingFolderRequest,
        });
    };
};

export const useAddReturnsToExistingFolderMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useAddReturnsToExistingFolderHook>>>,
        TError,
        { data: AddReturnsToExistingFolderRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAddReturnsToExistingFolderHook>>>,
    TError,
    { data: AddReturnsToExistingFolderRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const addReturnsToExistingFolder = useAddReturnsToExistingFolderHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useAddReturnsToExistingFolderHook>>>,
        { data: AddReturnsToExistingFolderRequest }
    > = (props) => {
        const { data } = props ?? {};

        return addReturnsToExistingFolder(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type AddReturnsToExistingFolderMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useAddReturnsToExistingFolderHook>>>
>;
export type AddReturnsToExistingFolderMutationBody = AddReturnsToExistingFolderRequest;
export type AddReturnsToExistingFolderMutationError = ErrorType<ProblemDetails>;

export const useAddReturnsToExistingFolder = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useAddReturnsToExistingFolderHook>>>,
        TError,
        { data: AddReturnsToExistingFolderRequest },
        TContext
    >;
}) => {
    const mutationOptions = useAddReturnsToExistingFolderMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useDeleteReturnsFromFolderHook = () => {
    const deleteReturnsFromFolder = useCustomInstance<DeleteReturnsFromFolderResponse>();

    return (deleteReturnsFromFolderRequest: DeleteReturnsFromFolderRequest) => {
        return deleteReturnsFromFolder({
            url: `/Report/DeleteReturnsFromFolder`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: deleteReturnsFromFolderRequest,
        });
    };
};

export const useDeleteReturnsFromFolderMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteReturnsFromFolderHook>>>,
        TError,
        { data: DeleteReturnsFromFolderRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteReturnsFromFolderHook>>>,
    TError,
    { data: DeleteReturnsFromFolderRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const deleteReturnsFromFolder = useDeleteReturnsFromFolderHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeleteReturnsFromFolderHook>>>,
        { data: DeleteReturnsFromFolderRequest }
    > = (props) => {
        const { data } = props ?? {};

        return deleteReturnsFromFolder(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteReturnsFromFolderMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteReturnsFromFolderHook>>>>;
export type DeleteReturnsFromFolderMutationBody = DeleteReturnsFromFolderRequest;
export type DeleteReturnsFromFolderMutationError = ErrorType<ProblemDetails>;

export const useDeleteReturnsFromFolder = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteReturnsFromFolderHook>>>,
        TError,
        { data: DeleteReturnsFromFolderRequest },
        TContext
    >;
}) => {
    const mutationOptions = useDeleteReturnsFromFolderMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useCreateFolderWithTaxReturnsHook = () => {
    const createFolderWithTaxReturns = useCustomInstance<CreateFolderWithTaxReturnsResponse>();

    return (createFolderWithTaxReturnsRequest: CreateFolderWithTaxReturnsRequest) => {
        return createFolderWithTaxReturns({
            url: `/Report/CreateFolderWithTaxReturns`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: createFolderWithTaxReturnsRequest,
        });
    };
};

export const useCreateFolderWithTaxReturnsMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateFolderWithTaxReturnsHook>>>,
        TError,
        { data: CreateFolderWithTaxReturnsRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateFolderWithTaxReturnsHook>>>,
    TError,
    { data: CreateFolderWithTaxReturnsRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const createFolderWithTaxReturns = useCreateFolderWithTaxReturnsHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCreateFolderWithTaxReturnsHook>>>,
        { data: CreateFolderWithTaxReturnsRequest }
    > = (props) => {
        const { data } = props ?? {};

        return createFolderWithTaxReturns(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type CreateFolderWithTaxReturnsMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCreateFolderWithTaxReturnsHook>>>
>;
export type CreateFolderWithTaxReturnsMutationBody = CreateFolderWithTaxReturnsRequest;
export type CreateFolderWithTaxReturnsMutationError = ErrorType<ProblemDetails>;

export const useCreateFolderWithTaxReturns = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateFolderWithTaxReturnsHook>>>,
        TError,
        { data: CreateFolderWithTaxReturnsRequest },
        TContext
    >;
}) => {
    const mutationOptions = useCreateFolderWithTaxReturnsMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useGetAmountsEntryOptionsHook = () => {
    const getAmountsEntryOptions = useCustomInstance<AmountDataEntryOptions>();

    return (params?: GetAmountsEntryOptionsParams, signal?: AbortSignal) => {
        return getAmountsEntryOptions({ url: `/Report/GetAmountsEntryOptions`, method: 'get', params, signal });
    };
};

export const getGetAmountsEntryOptionsQueryKey = (params?: GetAmountsEntryOptionsParams) =>
    [`/Report/GetAmountsEntryOptions`, ...(params ? [params] : [])] as const;

export const useGetAmountsEntryOptionsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetAmountsEntryOptionsHook>>>,
    TError = ErrorType<ProblemDetails>
>(
    params?: GetAmountsEntryOptionsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAmountsEntryOptionsHook>>>, TError, TData> }
): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAmountsEntryOptionsHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAmountsEntryOptionsQueryKey(params);

    const getAmountsEntryOptions = useGetAmountsEntryOptionsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAmountsEntryOptionsHook>>>> = ({ signal }) =>
        getAmountsEntryOptions(params, signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetAmountsEntryOptionsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAmountsEntryOptionsHook>>>>;
export type GetAmountsEntryOptionsQueryError = ErrorType<ProblemDetails>;

export const useGetAmountsEntryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetAmountsEntryOptionsHook>>>,
    TError = ErrorType<ProblemDetails>
>(
    params?: GetAmountsEntryOptionsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAmountsEntryOptionsHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetAmountsEntryOptionsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useGetAmountsEntriesHook = () => {
    const getAmountsEntries = useCustomInstance<AmountsEntriesResponse>();

    return (params?: GetAmountsEntriesParams, signal?: AbortSignal) => {
        return getAmountsEntries({ url: `/Report/GetAmountsEntries`, method: 'get', params, signal });
    };
};

export const getGetAmountsEntriesQueryKey = (params?: GetAmountsEntriesParams) =>
    [`/Report/GetAmountsEntries`, ...(params ? [params] : [])] as const;

export const useGetAmountsEntriesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetAmountsEntriesHook>>>,
    TError = ErrorType<ProblemDetails>
>(
    params?: GetAmountsEntriesParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAmountsEntriesHook>>>, TError, TData> }
): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAmountsEntriesHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAmountsEntriesQueryKey(params);

    const getAmountsEntries = useGetAmountsEntriesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAmountsEntriesHook>>>> = ({ signal }) =>
        getAmountsEntries(params, signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetAmountsEntriesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAmountsEntriesHook>>>>;
export type GetAmountsEntriesQueryError = ErrorType<ProblemDetails>;

export const useGetAmountsEntries = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetAmountsEntriesHook>>>,
    TError = ErrorType<ProblemDetails>
>(
    params?: GetAmountsEntriesParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAmountsEntriesHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetAmountsEntriesQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useSaveTaxReturnsHook = () => {
    const saveTaxReturns = useCustomInstance<TaxReturnSaveRecordsResponse>();

    return (taxReturnSaveRecordsRequest: TaxReturnSaveRecordsRequest) => {
        return saveTaxReturns({
            url: `/Report/SaveTaxReturns`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: taxReturnSaveRecordsRequest,
        });
    };
};

export const useSaveTaxReturnsMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSaveTaxReturnsHook>>>,
        TError,
        { data: TaxReturnSaveRecordsRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSaveTaxReturnsHook>>>,
    TError,
    { data: TaxReturnSaveRecordsRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const saveTaxReturns = useSaveTaxReturnsHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useSaveTaxReturnsHook>>>,
        { data: TaxReturnSaveRecordsRequest }
    > = (props) => {
        const { data } = props ?? {};

        return saveTaxReturns(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type SaveTaxReturnsMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSaveTaxReturnsHook>>>>;
export type SaveTaxReturnsMutationBody = TaxReturnSaveRecordsRequest;
export type SaveTaxReturnsMutationError = ErrorType<ProblemDetails>;

export const useSaveTaxReturns = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSaveTaxReturnsHook>>>,
        TError,
        { data: TaxReturnSaveRecordsRequest },
        TContext
    >;
}) => {
    const mutationOptions = useSaveTaxReturnsMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useUpdateTaxReturnsHook = () => {
    const updateTaxReturns = useCustomInstance<TaxReturnSaveRecordsResponse>();

    return (taxReturnSaveRecordsRequest: TaxReturnSaveRecordsRequest) => {
        return updateTaxReturns({
            url: `/Report/UpdateTaxReturns`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: taxReturnSaveRecordsRequest,
        });
    };
};

export const useUpdateTaxReturnsMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateTaxReturnsHook>>>,
        TError,
        { data: TaxReturnSaveRecordsRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateTaxReturnsHook>>>,
    TError,
    { data: TaxReturnSaveRecordsRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const updateTaxReturns = useUpdateTaxReturnsHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUpdateTaxReturnsHook>>>,
        { data: TaxReturnSaveRecordsRequest }
    > = (props) => {
        const { data } = props ?? {};

        return updateTaxReturns(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type UpdateTaxReturnsMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateTaxReturnsHook>>>>;
export type UpdateTaxReturnsMutationBody = TaxReturnSaveRecordsRequest;
export type UpdateTaxReturnsMutationError = ErrorType<ProblemDetails>;

export const useUpdateTaxReturns = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateTaxReturnsHook>>>,
        TError,
        { data: TaxReturnSaveRecordsRequest },
        TContext
    >;
}) => {
    const mutationOptions = useUpdateTaxReturnsMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useDeleteTaxReturnsHook = () => {
    const deleteTaxReturns = useCustomInstance<BaseStackResponse>();

    return (taxReturnDeleteRecordsRequest: TaxReturnDeleteRecordsRequest) => {
        return deleteTaxReturns({
            url: `/Report/DeleteTaxReturns`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: taxReturnDeleteRecordsRequest,
        });
    };
};

export const useDeleteTaxReturnsMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteTaxReturnsHook>>>,
        TError,
        { data: TaxReturnDeleteRecordsRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteTaxReturnsHook>>>,
    TError,
    { data: TaxReturnDeleteRecordsRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const deleteTaxReturns = useDeleteTaxReturnsHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeleteTaxReturnsHook>>>,
        { data: TaxReturnDeleteRecordsRequest }
    > = (props) => {
        const { data } = props ?? {};

        return deleteTaxReturns(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteTaxReturnsMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteTaxReturnsHook>>>>;
export type DeleteTaxReturnsMutationBody = TaxReturnDeleteRecordsRequest;
export type DeleteTaxReturnsMutationError = ErrorType<ProblemDetails>;

export const useDeleteTaxReturns = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteTaxReturnsHook>>>,
        TError,
        { data: TaxReturnDeleteRecordsRequest },
        TContext
    >;
}) => {
    const mutationOptions = useDeleteTaxReturnsMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useGetCalculationsHook = () => {
    const getCalculations = useCustomInstance<Calculation[]>();

    return (signal?: AbortSignal) => {
        return getCalculations({ url: `/Report/GetCalculations`, method: 'get', signal });
    };
};

export const getGetCalculationsQueryKey = () => [`/Report/GetCalculations`] as const;

export const useGetCalculationsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetCalculationsHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCalculationsHook>>>, TError, TData>;
}): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCalculationsHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCalculationsQueryKey();

    const getCalculations = useGetCalculationsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCalculationsHook>>>> = ({ signal }) => getCalculations(signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetCalculationsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCalculationsHook>>>>;
export type GetCalculationsQueryError = ErrorType<ProblemDetails>;

export const useGetCalculations = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetCalculationsHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCalculationsHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetCalculationsQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useGetEntitiesAndEntityGroupsHook = () => {
    const getEntitiesAndEntityGroups = useCustomInstance<EntitiesAndEntityGroupsResponse>();

    return (signal?: AbortSignal) => {
        return getEntitiesAndEntityGroups({ url: `/Report/GetEntitiesAndEntityGroups`, method: 'get', signal });
    };
};

export const getGetEntitiesAndEntityGroupsQueryKey = () => [`/Report/GetEntitiesAndEntityGroups`] as const;

export const useGetEntitiesAndEntityGroupsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetEntitiesAndEntityGroupsHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEntitiesAndEntityGroupsHook>>>, TError, TData>;
}): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEntitiesAndEntityGroupsHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetEntitiesAndEntityGroupsQueryKey();

    const getEntitiesAndEntityGroups = useGetEntitiesAndEntityGroupsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetEntitiesAndEntityGroupsHook>>>> = ({ signal }) =>
        getEntitiesAndEntityGroups(signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetEntitiesAndEntityGroupsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetEntitiesAndEntityGroupsHook>>>>;
export type GetEntitiesAndEntityGroupsQueryError = ErrorType<ProblemDetails>;

export const useGetEntitiesAndEntityGroups = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetEntitiesAndEntityGroupsHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEntitiesAndEntityGroupsHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetEntitiesAndEntityGroupsQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useGetCustomGroupsHook = () => {
    const getCustomGroups = useCustomInstance<CustomGroup[]>();

    return (signal?: AbortSignal) => {
        return getCustomGroups({ url: `/Report/GetCustomGroups`, method: 'get', signal });
    };
};

export const getGetCustomGroupsQueryKey = () => [`/Report/GetCustomGroups`] as const;

export const useGetCustomGroupsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetCustomGroupsHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomGroupsHook>>>, TError, TData>;
}): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomGroupsHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCustomGroupsQueryKey();

    const getCustomGroups = useGetCustomGroupsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCustomGroupsHook>>>> = ({ signal }) => getCustomGroups(signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetCustomGroupsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCustomGroupsHook>>>>;
export type GetCustomGroupsQueryError = ErrorType<ProblemDetails>;

export const useGetCustomGroups = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetCustomGroupsHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomGroupsHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetCustomGroupsQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useGetCustomRangesHook = () => {
    const getCustomRanges = useCustomInstance<CustomRange[]>();

    return (signal?: AbortSignal) => {
        return getCustomRanges({ url: `/Report/GetCustomRanges`, method: 'get', signal });
    };
};

export const getGetCustomRangesQueryKey = () => [`/Report/GetCustomRanges`] as const;

export const useGetCustomRangesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetCustomRangesHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomRangesHook>>>, TError, TData>;
}): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomRangesHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCustomRangesQueryKey();

    const getCustomRanges = useGetCustomRangesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCustomRangesHook>>>> = ({ signal }) => getCustomRanges(signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetCustomRangesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCustomRangesHook>>>>;
export type GetCustomRangesQueryError = ErrorType<ProblemDetails>;

export const useGetCustomRanges = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetCustomRangesHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCustomRangesHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetCustomRangesQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useSchedulePrintTaxReturnHook = () => {
    const schedulePrintTaxReturn = useCustomInstance<ScheduleBatchResponse>();

    return (scheduleReturnRequest: ScheduleReturnRequest) => {
        return schedulePrintTaxReturn({
            url: `/Report/SchedulePrintTaxReturn`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: scheduleReturnRequest,
        });
    };
};

export const useSchedulePrintTaxReturnMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSchedulePrintTaxReturnHook>>>,
        TError,
        { data: ScheduleReturnRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSchedulePrintTaxReturnHook>>>,
    TError,
    { data: ScheduleReturnRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const schedulePrintTaxReturn = useSchedulePrintTaxReturnHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useSchedulePrintTaxReturnHook>>>,
        { data: ScheduleReturnRequest }
    > = (props) => {
        const { data } = props ?? {};

        return schedulePrintTaxReturn(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type SchedulePrintTaxReturnMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSchedulePrintTaxReturnHook>>>>;
export type SchedulePrintTaxReturnMutationBody = ScheduleReturnRequest;
export type SchedulePrintTaxReturnMutationError = ErrorType<ProblemDetails>;

export const useSchedulePrintTaxReturn = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSchedulePrintTaxReturnHook>>>,
        TError,
        { data: ScheduleReturnRequest },
        TContext
    >;
}) => {
    const mutationOptions = useSchedulePrintTaxReturnMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useDownloadTaxReturnPdfHook = () => {
    const downloadTaxReturnPdf = useCustomInstance<Blob>();

    return (params?: DownloadTaxReturnPdfParams) => {
        return downloadTaxReturnPdf({ url: `/Report/DownloadTaxReturnPdf`, method: 'post', params, responseType: 'blob' });
    };
};

export const useDownloadTaxReturnPdfMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadTaxReturnPdfHook>>>,
        TError,
        { params?: DownloadTaxReturnPdfParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDownloadTaxReturnPdfHook>>>,
    TError,
    { params?: DownloadTaxReturnPdfParams },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const downloadTaxReturnPdf = useDownloadTaxReturnPdfHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDownloadTaxReturnPdfHook>>>,
        { params?: DownloadTaxReturnPdfParams }
    > = (props) => {
        const { params } = props ?? {};

        return downloadTaxReturnPdf(params);
    };

    return { mutationFn, ...mutationOptions };
};

export type DownloadTaxReturnPdfMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDownloadTaxReturnPdfHook>>>>;

export type DownloadTaxReturnPdfMutationError = ErrorType<ProblemDetails>;

export const useDownloadTaxReturnPdf = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDownloadTaxReturnPdfHook>>>,
        TError,
        { params?: DownloadTaxReturnPdfParams },
        TContext
    >;
}) => {
    const mutationOptions = useDownloadTaxReturnPdfMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useIsTaxReturnPdfAvailableHook = () => {
    const isTaxReturnPdfAvailable = useCustomInstance<boolean>();

    return (taxReturnPdfReportAvailableRequest: TaxReturnPdfReportAvailableRequest) => {
        return isTaxReturnPdfAvailable({
            url: `/Report/IsTaxReturnPdfAvailable`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: taxReturnPdfReportAvailableRequest,
        });
    };
};

export const useIsTaxReturnPdfAvailableMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useIsTaxReturnPdfAvailableHook>>>,
        TError,
        { data: TaxReturnPdfReportAvailableRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useIsTaxReturnPdfAvailableHook>>>,
    TError,
    { data: TaxReturnPdfReportAvailableRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const isTaxReturnPdfAvailable = useIsTaxReturnPdfAvailableHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useIsTaxReturnPdfAvailableHook>>>,
        { data: TaxReturnPdfReportAvailableRequest }
    > = (props) => {
        const { data } = props ?? {};

        return isTaxReturnPdfAvailable(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type IsTaxReturnPdfAvailableMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useIsTaxReturnPdfAvailableHook>>>>;
export type IsTaxReturnPdfAvailableMutationBody = TaxReturnPdfReportAvailableRequest;
export type IsTaxReturnPdfAvailableMutationError = ErrorType<ProblemDetails>;

export const useIsTaxReturnPdfAvailable = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useIsTaxReturnPdfAvailableHook>>>,
        TError,
        { data: TaxReturnPdfReportAvailableRequest },
        TContext
    >;
}) => {
    const mutationOptions = useIsTaxReturnPdfAvailableMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useDoesCalculationDiagnosticsExistHook = () => {
    const doesCalculationDiagnosticsExist = useCustomInstance<boolean | null>();

    return (params?: DoesCalculationDiagnosticsExistParams, signal?: AbortSignal) => {
        return doesCalculationDiagnosticsExist({ url: `/Report/DoesCalculationDiagnosticsExist`, method: 'get', params, signal });
    };
};

export const getDoesCalculationDiagnosticsExistQueryKey = (params?: DoesCalculationDiagnosticsExistParams) =>
    [`/Report/DoesCalculationDiagnosticsExist`, ...(params ? [params] : [])] as const;

export const useDoesCalculationDiagnosticsExistQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useDoesCalculationDiagnosticsExistHook>>>,
    TError = ErrorType<ProblemDetails>
>(
    params?: DoesCalculationDiagnosticsExistParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDoesCalculationDiagnosticsExistHook>>>, TError, TData> }
): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDoesCalculationDiagnosticsExistHook>>>, TError, TData> & {
    queryKey: QueryKey;
} => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getDoesCalculationDiagnosticsExistQueryKey(params);

    const doesCalculationDiagnosticsExist = useDoesCalculationDiagnosticsExistHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useDoesCalculationDiagnosticsExistHook>>>> = ({ signal }) =>
        doesCalculationDiagnosticsExist(params, signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type DoesCalculationDiagnosticsExistQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDoesCalculationDiagnosticsExistHook>>>
>;
export type DoesCalculationDiagnosticsExistQueryError = ErrorType<ProblemDetails>;

export const useDoesCalculationDiagnosticsExist = <
    TData = Awaited<ReturnType<ReturnType<typeof useDoesCalculationDiagnosticsExistHook>>>,
    TError = ErrorType<ProblemDetails>
>(
    params?: DoesCalculationDiagnosticsExistParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDoesCalculationDiagnosticsExistHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useDoesCalculationDiagnosticsExistQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useGetCalculationDiagnosticsHook = () => {
    const getCalculationDiagnostics = useCustomInstance<Blob>();

    return (params?: GetCalculationDiagnosticsParams, signal?: AbortSignal) => {
        return getCalculationDiagnostics({ url: `/Report/GetCalculationDiagnostics`, method: 'get', params, responseType: 'blob', signal });
    };
};

export const getGetCalculationDiagnosticsQueryKey = (params?: GetCalculationDiagnosticsParams) =>
    [`/Report/GetCalculationDiagnostics`, ...(params ? [params] : [])] as const;

export const useGetCalculationDiagnosticsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetCalculationDiagnosticsHook>>>,
    TError = ErrorType<ProblemDetails>
>(
    params?: GetCalculationDiagnosticsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCalculationDiagnosticsHook>>>, TError, TData> }
): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCalculationDiagnosticsHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCalculationDiagnosticsQueryKey(params);

    const getCalculationDiagnostics = useGetCalculationDiagnosticsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCalculationDiagnosticsHook>>>> = ({ signal }) =>
        getCalculationDiagnostics(params, signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetCalculationDiagnosticsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCalculationDiagnosticsHook>>>>;
export type GetCalculationDiagnosticsQueryError = ErrorType<ProblemDetails>;

export const useGetCalculationDiagnostics = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetCalculationDiagnosticsHook>>>,
    TError = ErrorType<ProblemDetails>
>(
    params?: GetCalculationDiagnosticsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCalculationDiagnosticsHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetCalculationDiagnosticsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useGetEntityEfileDataHook = () => {
    const getEntityEfileData = useCustomInstance<string>();

    return (params?: GetEntityEfileDataParams, signal?: AbortSignal) => {
        return getEntityEfileData({ url: `/Report/GetEntityEfileData`, method: 'get', params, signal });
    };
};

export const getGetEntityEfileDataQueryKey = (params?: GetEntityEfileDataParams) =>
    [`/Report/GetEntityEfileData`, ...(params ? [params] : [])] as const;

export const useGetEntityEfileDataQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetEntityEfileDataHook>>>,
    TError = ErrorType<ProblemDetails>
>(
    params?: GetEntityEfileDataParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEntityEfileDataHook>>>, TError, TData> }
): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEntityEfileDataHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetEntityEfileDataQueryKey(params);

    const getEntityEfileData = useGetEntityEfileDataHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetEntityEfileDataHook>>>> = ({ signal }) =>
        getEntityEfileData(params, signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetEntityEfileDataQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetEntityEfileDataHook>>>>;
export type GetEntityEfileDataQueryError = ErrorType<ProblemDetails>;

export const useGetEntityEfileData = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetEntityEfileDataHook>>>,
    TError = ErrorType<ProblemDetails>
>(
    params?: GetEntityEfileDataParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetEntityEfileDataHook>>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetEntityEfileDataQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};
